import { render } from "./AdminOverviewView.vue?vue&type=template&id=78dad73e&scoped=true"
import script from "./AdminOverviewView.vue?vue&type=script&lang=js"
export * from "./AdminOverviewView.vue?vue&type=script&lang=js"

import "./AdminOverviewView.vue?vue&type=style&index=0&id=78dad73e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78dad73e"]])

export default __exports__